<div [style]="'display: flex;align-items: center;gap:'+gap+''">
  <div *ngIf="icon !==' '"
    [style]="'width: 30px;height: 30px; border-radius: 50px;background-color:'+bgIcon+';display: flex;align-items: center;justify-content: center;'">
    <img src="./assets/img/{{icon}}" alt="" style="width: 20px; height: 20px;" />
  </div>
  <p class=" {{type}}" [style]="'font-size:'+size+'px; font-weight:'+fontWeigth+';opacity:'+opacity+';'">{{text}}</p>
</div>
